import React, { useEffect, useRef, useState } from 'react';
import {
    DataGrid,
    Column,
    HeaderFilter,
    Search,
    ColumnFixing,
    Scrolling,
    FilterRow,
    FilterPanel,
    // Selection,
    Toolbar,
    Item
} from 'devextreme-react/data-grid';
import Button2 from 'devextreme-react/button';
import { saveAs } from "file-saver";
import ExcelJS from 'exceljs'

import * as DynamicQueries from '../../services/DynamicQueries';


const Operations = () => {
    const [dataGrid, setDataGrid] = useState([]);

    const dataGridRef = useRef(null);

    const getOperationsData = () => {
        DynamicQueries.getData('/getDataOperations', 'operations').then((resp) => {
            console.log("🚀 ~ DynamicQueries.getData ~ resp.data.operations:", resp.data.operations)
            setDataGrid(resp.data.operations)
        })
    };

    const onExportXLS = async () => {
        const dataGrid = dataGridRef.current.instance;

        const dataSource = dataGrid.option('dataSource');

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('DataGrid Data');

        const headers = dataGrid.getVisibleColumns().map(column => column.caption);
        worksheet.addRow(headers);

        dataSource.forEach(item => {
            const rowData = dataGrid.getVisibleColumns().map(column => item[column.dataField] || '');
            worksheet.addRow(rowData);
        });

        const blob = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([blob], { type: 'application/octet-stream' }), 'ListaDeOperaciones.xlsx');

    };

    useEffect(() => {
        getOperationsData();
    }, [])

    return (
        <>
            <div>
                <div className="relative pb-6">
                    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <h3 className="!text-2xl !ont-extrabold !tracking-tight !text-black md:!text-3xl lg:!text-4xl">Operaciones</h3>
                    </div>
                </div>
            </div>

            <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
                <div className="space-y-6 sm:px-6 lg:px-0 lg:col-span-12">
                    <div className="shadow-lg sm:rounded-md sm:overflow-hidden">
                        <div className="bg-gray-50 py-6 px-4 space-y-6 sm:p-6">
                            <div className="col-span-12 sm:col-span-3">
                                <DataGrid
                                    ref={dataGridRef}
                                    dataSource={dataGrid}
                                    allowColumnReordering={true}
                                    allowColumnResizing={true}
                                    columnResizingMode="widget"
                                    columnAutoWidth={true}
                                    showRowLines={false}
                                    showBorders={true}
                                    rowAlternationEnabled={true}
                                    displayMode='full'
                                    style={{ height: '75vh', width: '100%' }}
                                >
                                    {/* <Selection
                                        mode="multiple"
                                        selectAllMode='allPages'
                                        showCheckBoxesMode='always'
                                    /> */}
                                    <FilterRow visible={true} />
                                    <FilterPanel visible={true} />
                                    <Scrolling rowRenderingMode='infinity'></Scrolling>
                                    <ColumnFixing enabled={true} />
                                    <HeaderFilter visible={true} />

                                    <Toolbar>
                                        <Item location="after">
                                            <Button2
                                                icon='refresh'
                                                onClick={getOperationsData}
                                            />
                                        </Item>
                                        <Item location="after">
                                            <Button2
                                                icon='xlsfile'
                                                onClick={onExportXLS}
                                            />
                                        </Item>
                                    </Toolbar>

                                    <Column dataField='id' caption='ID'>
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='operations_code' caption='Código de Operación'>
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='brand_name' caption='Marca' >
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='model_name' caption='Modelo' >
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='year_name' caption='Año'>
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='version_name' caption='Versión' >
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='insurance_carrier' caption='Aseguradora' >
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='price' caption='Precio' >
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='date_operation' caption='Fecha' >
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    
                                    <Column dataField='page' caption='Cotizador' >
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>
                                </DataGrid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Operations